import VehicleImage from '../VehicleImage';
import { Text } from '../typography';
import { truncate } from '../../utilities';
import styles from './Dropdown.module.scss';

export default function VehicleOption({ vehicle }) {
  const { id, year, make, model, unitNumber, imageUrl, type, subtype, color } =
    vehicle;
  return (
    <div className={styles.vehicleCardContainer} key={`vehicle-option-${id}`}>
      <VehicleImage
        className={styles.vehicleImage}
        vehicle={{ imageUrl, type, subtype, color }}
      />
      <div className={styles.fullWidth}>
        <Text size="md" noSelect noMargin weight="semiBold">
          {truncate(unitNumber, 15)}
        </Text>
        <Text noMargin noSelect size="sm" weight="semiBold" textAlign="right">
          {truncate(`${year || ''} ${make} ${model}`, 30)}
        </Text>
      </div>
    </div>
  );
}
